import get from "lodash/get"
import React from "react"
import { cleanedText } from "../../util"
import { testimonialTransformer } from "../../utils/transformers"
import Callout from "../../components/Callout"
import Link from "../../components/LinkWrapper"
import RichText from "../../components/RichText"
import Testimonial from "../../components/Testimonial"

export interface SolutionDifferentiatorProps {
  /**
   * The Kontent data to render as a differentiator
   * */
  differentiator: any
}

/**
 * Renders a `<CallOut />`, `<CallOut />` group, or `<Testimonial />` depending on the differentiator type
 */
const SolutionDifferentiator = ({
  differentiator,
}: SolutionDifferentiatorProps) => {
  switch (differentiator.system.type) {
    case "callout":
      return (
        <Callout
          contentItem={differentiator}
          style={`card`}
          direction={`column`}
          textSize={`xs`}
        />
      )
    case "callout_group":
      const localizedLinkLabel = get(
        differentiator,
        "elements.localized_link_label.value[0].elements.localized_string_value.value"
      )
      const customLinkLabel = get(
        differentiator,
        "elements.custom_link_label.value"
      )
      const linkTo = get(
        differentiator,
        "elements.link_to.value[0].resolved_url"
      )
      const linkAnalyticsTitle = get(
        differentiator,
        "elements.link_to.value[0].system.name"
      )
      const linkLabel = customLinkLabel
        ? customLinkLabel
        : localizedLinkLabel
        ? localizedLinkLabel
        : null

      const footnote = cleanedText(
        get(differentiator, "elements.footnote.value")
      )
      return (
        <>
          <div className="-ml-4 -mt-4 flex flex-wrap lg:flex-nowrap lg:grow-0">
            {differentiator.elements.callouts.value.map((callOut, index) => (
              <div className="pl-4 mt-4 flex items-stretch" key={index}>
                <Callout
                  className={`lg:grow`}
                  contentItem={callOut}
                  style={`card`}
                  direction={`column`}
                  textSize={`xs`}
                />
              </div>
            ))}
          </div>
          {linkTo ? (
            <p className="text-sm mt-3">
              <Link
                className={`text-action-link no-underline inline-block hover:underline hover:text-action`}
                to={linkTo}
                data-analytics-title={linkAnalyticsTitle}
              >
                {linkLabel}
                <i className="icon-chevron-right" />
              </Link>
            </p>
          ) : null}
          {footnote && (
            <div className="text-gray-700 mt-3 text-xs leading-snug">
              <RichText content={footnote} />
            </div>
          )}
        </>
      )
    case "testimonial":
      return <Testimonial {...testimonialTransformer(differentiator)} />
    default:
      return <p>{differentiator.system.type}</p>
  }
}

export default SolutionDifferentiator
